import { render, staticRenderFns } from "./CustomMsg.vue?vue&type=template&id=700c92e8&"
import script from "./CustomMsg.vue?vue&type=script&lang=js&"
export * from "./CustomMsg.vue?vue&type=script&lang=js&"
import style0 from "./CustomMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports